export const CHANGE_LOCALE = "@app/CHANGE_LOCALE";
export const SET_BREADCRUMB = "@app/SET_BREADCRUMB";
